import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { WhyChoose } from '../components/WhyChoose';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { LegalNotice } from '../components/LegalNotice';
import { SiteFooter } from '../components/SiteFooter';
export function Landing() {
  return <div className="min-h-screen w-full bg-ivory-50 font-sans text-graphite-900" data-id="element-196" data-mp="3gkkkou6p3u5">
      <SiteHeader data-id="element-197" data-mp="882jl7cncuch" />
      <main data-id="element-198" data-mp="87kcffog4vps">
        <Hero data-id="element-199" data-mp="88vk3ql0inm6" />
        <Intro data-id="element-200" data-mp="88c96tts4zhn" />
        <WhyChoose data-id="element-201" data-mp="89x4wmrtyoh3" />
        <Services data-id="element-202" data-mp="c9e9zf3chjlq" />
        <Testimonials data-id="element-203" data-mp="c9xhs2za6rm1" />
        <Contact data-id="element-204" data-mp="c84aclgug3cz" />
        <LegalNotice data-id="element-205" data-mp="c8mfk7lhhrx1" />
      </main>
      <SiteFooter data-id="element-206" data-mp="h8imofph9zgt" />
    </div>;
}